/**
 * Editorial marquee — outlined gold that fills on hover.
 * Matches parent-brand rhythm exactly.
 */
export default function EditorialMarquee() {
  const items = Array.from({ length: 10 });
  return (
    <section
      data-testid="editorial-marquee"
      className="bg-ink border-y border-white/10 py-8 md:py-12 overflow-hidden select-none"
    >
      <div className="marquee">
        <div className="marquee__track" style={{ animationDuration: "60s", gap: 0 }}>
          {items.map((_, i) => (
            <span
              key={i}
              className="font-display italic leading-none tracking-tighter text-outline-gold cursor-default"
              style={{ fontSize: "clamp(4rem, 10vw, 10vw)" }}
            >
              <span className="mx-10">BRINGING THE WORLD TO YOU</span>
              <span className="mx-6 text-[#C5A059]" style={{ WebkitTextStroke: 0, fontStyle: "normal", fontSize: "clamp(2.5rem, 4vw, 4vw)" }}>✦</span>
            </span>
          ))}
        </div>
        <div className="marquee__track" style={{ animationDuration: "60s", gap: 0 }} aria-hidden="true">
          {items.map((_, i) => (
            <span
              key={i}
              className="font-display italic leading-none tracking-tighter text-outline-gold cursor-default"
              style={{ fontSize: "clamp(4rem, 10vw, 10vw)" }}
            >
              <span className="mx-10">BRINGING THE WORLD TO YOU</span>
              <span className="mx-6 text-[#C5A059]" style={{ WebkitTextStroke: 0, fontStyle: "normal", fontSize: "clamp(2.5rem, 4vw, 4vw)" }}>✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
